import React from 'react';
import { getFormattedDate } from '../../../../helpers/localize';
import { useParams } from 'react-router-dom';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import MetricsButton from '../../../Shared/Table/widgets/MetricsButton';
import { TABLE_KEYS } from '../../../../redux_store/reducer/reducers/tableReducer/tableReducer';

const TableActions = (props) => {
  const { accountUuid: paramAccountUuid } = useParams();
  const tableKey = paramAccountUuid ? TABLE_KEYS.assessmentsDSTable : TABLE_KEYS.assessmentsTable;

  return <>
    <MetricsButton title={'assessments'}
                   aggregations={props.aggregations}
                   filter={props.tableFilter}
    />
    <DownloadTableFile
      fileName={`Assessments ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-surveys.csv'}
      tableKey={tableKey}
      {...props}
    />
  </>;
};

export default TableActions;
